import React from 'react';
import { Helmet } from 'react-helmet';
import { MdDelete } from 'react-icons/md';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import DatePagination from 'components/DatePagination';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import RoleButton from 'components/RoleButton';
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import RoleModal from 'components/RoleModal';
import {
    SPRAY_SUBMISSIONS_DELETE_NAMESPACE,
    SPRAY_SUBMISSIONS_LOAD_NAMESPACE
} from 'services/spraySubmissions/constants';
import { Loader } from 'semantic-ui-react';
import { ErrorGate } from 'components/ErrorGate';
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import { DELETE_MODAL_QUERY_STRING_PARAM } from 'components/VirtualizedTable/constants';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import SaveMessage from 'components/SaveMessage';

import SubmissionsVirtualizedTable from './components/SubmissionsVirtualizedTable';
import SubmissionCreateForm from './components/SubmissionCreateForm';
import { CREATE_SPRAY_SUBMISSION_MODAL } from './constants';
import SubmissionsRequest from './components/SubmissionsRequest';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

function Submissions(): React.ReactElement {
    return (
        <ErrorBoundary
            namespace="SpraySubmissions"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <Helmet>
                <title>Submissions - {REACT_APP_PROJECT_NAME}</title>
            </Helmet>
            <Online>
                <SubmissionsRequest />
            </Online>
            <PageTitleAndFilters
                title="Submissions"
                CustomSearch={<DatePagination />}
                MessageComponent={
                    <SaveMessage
                        namespace={[SPRAY_SUBMISSIONS_DELETE_NAMESPACE]}
                    />
                }
                FirstActionButton={
                    <SingleActiveTableRowGate>
                        <RoleButton
                            requiredRoles={[ADMIN, MANAGER]}
                            params={{
                                [DELETE_MODAL_QUERY_STRING_PARAM]: true
                            }}
                            buttonProps={{
                                icon: true,
                                color: 'black',
                                basic: true,
                                style: {
                                    marginRight: 0,
                                    marginLeft: 8
                                }
                            }}
                        >
                            <ButtonIconWrapper>
                                <MdDelete
                                    style={{
                                        fontSize: 20
                                    }}
                                />
                            </ButtonIconWrapper>
                            Delete
                        </RoleButton>
                    </SingleActiveTableRowGate>
                }
                SecondActionButton={
                    <RoleButton
                        requiredRoles={[ADMIN, MANAGER]}
                        buttonProps={{
                            secondary: true,
                            style: {
                                marginRight: 0,
                                marginLeft: 8
                            }
                        }}
                        params={{
                            [CREATE_SPRAY_SUBMISSION_MODAL]: true
                        }}
                        ignoreSeason
                    >
                        Create submission
                    </RoleButton>
                }
                hideFilters
            />
            <PageWrapper top={0} bottom={50}>
                <LoadingGate
                    namespace={SPRAY_SUBMISSIONS_LOAD_NAMESPACE}
                    LoadingComponent={
                        <PageWrapper>
                            <Loader active inline="centered" />
                        </PageWrapper>
                    }
                >
                    <ErrorGate namespace={SPRAY_SUBMISSIONS_LOAD_NAMESPACE}>
                        <PageTitleAndFiltersPusher>
                            <SubmissionsVirtualizedTable tableId="spraySubmissions" />
                        </PageTitleAndFiltersPusher>
                    </ErrorGate>
                </LoadingGate>
            </PageWrapper>
            <RoleModal
                requiredRoles={[ADMIN, MANAGER]}
                param={CREATE_SPRAY_SUBMISSION_MODAL}
                size="fullscreen"
                ignoreSeason
            >
                <SubmissionCreateForm />
            </RoleModal>
        </ErrorBoundary>
    );
}

export default Submissions;
